export default __webpack_public_path__ + "static/media/team-ico.d8e40ba8.svg";